import React, { useState } from 'react';
import {
  Button,
  Box,
  Typography,
} from '@mui/material';
import {
  CloudDownload as ImportIcon,
} from '@mui/icons-material';
import GoogleFormsImportDialog from './GoogleFormsImportDialog';

interface GoogleFormsImportButtonProps {
  onImport: (importedData: any) => void;
  gradeLevel: string;
  teacherStandards?: string[];
  state?: string;
}

const GoogleFormsImportButton: React.FC<GoogleFormsImportButtonProps> = ({
  onImport,
  gradeLevel,
  teacherStandards,
  state
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleImportClick = () => {
    setDialogOpen(true);
  };

  const handleImportComplete = (importedData: any) => {
    onImport(importedData);
    setDialogOpen(false);
  };

  return (
    <Box sx={{ mt: 2, mb: 1 }}>
      <Box sx={{ 
        p: 2, 
        border: '1px dashed #e0e0e0', 
        borderRadius: 1.5, 
        textAlign: 'center',
        backgroundColor: '#fafafa'
      }}>
        <Typography variant="subtitle1" gutterBottom color="text.secondary">
          Import from Google Forms
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Quickly create tests by importing your existing Google Forms
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="medium"
          startIcon={<ImportIcon />}
          onClick={handleImportClick}
          sx={{
            px: 3,
            py: 1,
            backgroundColor: '#4285f4',
            '&:hover': {
              backgroundColor: '#3367d6',
            }
          }}
        >
          Import from Google Forms
        </Button>
      </Box>

      <GoogleFormsImportDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onImport={handleImportComplete}
        gradeLevel={gradeLevel}
        teacherStandards={teacherStandards}
        state={state}
      />
    </Box>
  );
};

export default GoogleFormsImportButton; 